"use client"

import { Checkbox, Label } from "@rarible_int/anaconda_ui_components"
import { reatomComponent } from "@reatom/react"
import { useMolecule } from "bunshi/react"
import { NftFiltersMoleculeReatom } from "../store.reatom"

interface Props {
  traitName: string
  traitValue: string
  count: number
}

const toggleTraitValueSelection = (
  traitsSelection: Set<string> | undefined,
  valueToToggle: string,
): Set<string> | undefined => {
  if (!traitsSelection || !traitsSelection.size) {
    return new Set([valueToToggle])
  }

  if (!traitsSelection.has(valueToToggle)) {
    return new Set(traitsSelection.add(valueToToggle))
  }

  if (traitsSelection.size > 1) {
    traitsSelection.delete(valueToToggle)
    return new Set(traitsSelection)
  }

  return undefined
}

export const TraitValue = reatomComponent<Props>(
  ({ traitName, traitValue, count }) => {
    const { traitsSelection, setTraitsSelection } = useMolecule(
      NftFiltersMoleculeReatom,
    )

    const selection = traitsSelection()
    const traitSet = selection[traitName]
    const selected = traitSet ? traitSet.has(traitValue) : false

    const toggleTraitSelection = () => {
      const currentSelection = traitsSelection()
      const currentTraitSet = currentSelection[traitName]
      const newTraitSet = toggleTraitValueSelection(currentTraitSet, traitValue)

      setTraitsSelection({
        ...currentSelection,
        [traitName]: newTraitSet,
      })
    }

    return (
      <div className="flex items-center gap-3">
        <Checkbox
          checked={selected}
          onCheckedChange={toggleTraitSelection}
          id={traitValue}
        />
        <Label
          className="flex-1 cursor-pointer overflow-hidden text-md"
          htmlFor={traitValue}
        >
          <div className="flex items-center justify-between gap-1">
            <span className="truncate">{traitValue}</span>
            <span className="flex-shrink-0 text-foreground/60">{count}</span>
          </div>
        </Label>
      </div>
    )
  },
  "TraitValue",
)
